import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/EnablePerm.module.css";
import config from "../../../config";
import { pbdkf2 } from "../../../Utils/OstreonEncryption";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

const base_url = config.base_url;
function EnablePerm({ OnClose, OnConfirm }) {
  const [password, setPassword] = useState("");
  const auth = useAuth();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.EnablePerm
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => (document.documentElement.style.overflow = "unset");
  }, []);
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.EnablePerm);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [showPassword, setShowPassword] = useState(false);
  const [msg, setMsg] = useState({
    error: "",
    success: "",
  });
  const clearMsg = () => {
    setTimeout(() => {
      setMsg({
        error: "",
        success: "",
      });
    }, 3000);
  };
  const handleClick = async () => {
    if (password === "") {
      setMsg({
        error: content.enablePermError1,
        success: "",
      });
      clearMsg();
      return;
    }
    const [pbdkf2hash] = await pbdkf2(password, "OSTREON", 100000, 32 * 8);
    fetch(base_url + "user/MFApermissions", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `password=${pbdkf2hash}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200 || 500) return res.json();
        else throw new Error();
      })
      .then((data) => {
        if (data.error === "") {
          setMsg({ ...msg, success: "Correct!" });
          //Aquí deberíamos de hacer la acción de abrir el siguiente popup
          //auth.setMFApermissions(true)
          auth.updateHash(pbdkf2hash);
          OnConfirm();
        } else {
          setMsg({ ...msg, error: dublicatedcontent?.wrong_password });
          clearMsg();
        }
        return;
      })
      .catch((e) => {
        console.log(e);
        setMsg({ ...msg, error: dublicatedcontent.dublicatedText78 });
        clearMsg();
      });
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleClick(e);
    }
  };
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.main_box}
      >
        <div onClick={OnClose} className={styles.close_logo} />
        <div className={styles.title}>{content.enablePermTitle1}</div>
        <div className={styles.subtitle}>{content.enablePermTitle2}</div>
        <div className={styles.title1}>{content.enablePermText1}</div>
        <div className={styles.title2}>{content.enablePermText2}</div>

        <div className={styles.field}>
          <input
            type={showPassword ? "text" : "password"}
            onKeyDown={handleEnter}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`${styles.user_input} ${
              msg.error ? styles.field_error : ""
            }`}
            placeholder={dublicatedcontent.dublicatedText62}
          />
          <div
            onClick={() => {
              setShowPassword(!showPassword);
            }}
            className={styles.password_button}
          >
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                fill="#B3B3B3"
              />
              <path
                d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                fill="#B3B3B3"
              />
            </svg>
          </div>
          {
            <div className={styles.login_error}>
              {msg.error ? msg.error : null}
            </div>
          }
          {
            <div className={styles.login_success}>
              {msg.success ? msg.success : null}
            </div>
          }
        </div>

        <div className={styles.footer}>
          <div onClick={() => handleClick()} className={styles.bluebutton}>
            {content.enablePermText4}
          </div>
          <div onClick={OnClose} className={styles.whitebutton}>
            {dublicatedcontent.dublicatedText76}
          </div>
        </div>
      </div>
    </div>
  );
}
export { EnablePerm };
